import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid'

import { Link, Text } from '../../common/designs'

interface Props {
  title: string
  description: string
  orderString: string
  instructionsLink: string
}

const GetStartedSection = ({ title, description, orderString, instructionsLink }: Props) => {
  return (
    <div className='py-4'>
      <div className='flex items-center gap-3 sm:gap-4'>
        <div
          className='flex size-8 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-xs font-semibold tabular-nums text-gray-600'
          aria-hidden
        >
          {orderString}
        </div>
        <div className='min-w-0 flex-1 space-y-1'>
          <Text size='l' weight={700} color='darkGray' className='leading-snug tracking-tight'>
            {title}
          </Text>
          <Text size='s' color='gray' className='leading-relaxed'>
            {description}
          </Text>
        </div>
        <div className='shrink-0'>
          <Link
            href={instructionsLink}
            target='_blank'
            rel='noopener noreferrer'
            size='s'
            className='inline-flex items-center gap-0.5 whitespace-nowrap font-medium text-primary-700 hover:!bg-transparent hover:underline'
          >
            Documentation
            <ArrowTopRightOnSquareIcon className='size-3.5 shrink-0 translate-y-px opacity-70' aria-hidden />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default GetStartedSection
